<div class="zag-form-field">
  @if (label()) {
  <label class="zag-form-field-label" [attr.for]="forId()" [class.required]="required()">
    {{ label() }} @if (required()) {
    <span class="zag-form-field-required" aria-hidden="true">*</span>
    }
  </label>
  }

  <div class="zag-form-field-control">
    <ng-content></ng-content>
  </div>

  @if (hint() && !error()) {
  <div class="zag-form-field-hint" [attr.id]="descId()">{{ hint() }}</div>
  } @if (error()) {
  <div class="zag-form-field-error" role="alert" aria-live="assertive" [attr.id]="descId()">{{ error() }}</div>
  }
</div>
